module.exports = __webpack_public_path__ + "static/libros-31f82fa62a604eab2b95efb9a6773673.png";